const mxn = new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" });

export const money = (v) => mxn.format(Number(v || 0));

export const dateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("es-MX", { timeZone: "America/Mexico_City", dateStyle: "short", timeStyle: "short" }) : "-";

export const dateOnly = (iso) =>
  iso ? new Date(iso).toLocaleDateString("es-MX", { timeZone: "America/Mexico_City" }) : "-";

export const fmtClabe = (c) => (c ? `${c.slice(0, 3)} ${c.slice(3, 6)} ${c.slice(6, 17)} ${c.slice(17)}` : "-");

const W = [3, 7, 1];
export const isValidClabe = (c) => {
  if (!/^\d{18}$/.test(c)) return false;
  const sum = c.slice(0, 17).split("").reduce((s, d, i) => s + ((Number(d) * W[i % 3]) % 10), 0);
  return (10 - (sum % 10)) % 10 === Number(c[17]);
};

export const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

export const KYC_LABEL = { pendiente: "Pendiente", en_revision: "En revisión", aprobado: "Aprobado", rechazado: "Rechazado" };

export const TX_LABEL = { liquidada: "Liquidada", pendiente: "Pendiente", devuelta: "Devuelta" };
